var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_2124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 13.2719C28.2193 12.7456 28.9649 10.7719 28.9649 10.7719C28.9649 10.8157 29.1842 10.2456 29.2719 9.93855L29.4474 10.728C29.4474 10.728 29.9298 12.8771 30.0175 13.3157H28V13.2719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H33C34.6569 24 36 22.6569 36 21V3C36 1.34315 34.6569 0 33 0H3ZM24.4035 13.5351C24.4035 15.3772 22.7368 16.6052 20.1491 16.6052C19.0526 16.6052 18 16.3859 17.4298 16.1228L17.7807 14.1052L18.0877 14.2368C18.8772 14.5877 19.4035 14.7193 20.3684 14.7193C21.0702 14.7193 21.8158 14.4561 21.8158 13.8421C21.8158 13.4473 21.5088 13.1842 20.5439 12.7456C19.6228 12.307 18.3947 11.6052 18.3947 10.3333C18.3947 8.57892 20.1053 7.39471 22.5175 7.39471C23.4386 7.39471 24.2281 7.57015 24.7105 7.78945L24.3597 9.71928L24.1842 9.54384C23.7456 9.3684 23.1754 9.19296 22.3421 9.19296C21.4211 9.23682 20.9825 9.63156 20.9825 9.98243C20.9825 10.3772 21.5088 10.6842 22.3421 11.0789C23.7456 11.7368 24.4035 12.4824 24.4035 13.5351ZM30.9825 7.52626H29.0965C28.5263 7.52626 28.0877 7.7017 27.8246 8.27188L24.2281 16.4736H26.7719C26.7719 16.4736 27.2105 15.3771 27.2982 15.114H30.4123C30.5 15.421 30.7193 16.4298 30.7193 16.4298H33L30.9825 7.52626ZM3.04386 7.4386L3 7.61404C5.9386 8.3158 7.86842 10.0263 8.70175 12.1316L7.86842 8.18422C7.73684 7.61404 7.3421 7.4386 6.81579 7.4386H3.04386ZM14.0088 7.52629L10.193 16.4298H7.60526L5.41228 8.97366C6.99123 9.98243 8.30702 11.5614 8.78947 12.6579L9.05263 13.5789L11.4211 7.48243H14.0088V7.52629ZM17.4298 7.48243H15.0175L13.4825 16.4298H15.8947L17.4298 7.48243Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_2124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e17631287e8f1f2564846d467448aa9e.svg";
export { ForwardRef as ReactComponent };